export const MAGAZINE_GROUP_CODE = 'CM';

/**
 * A plain `localeCompare` compares the leading character, so "¿Qué Tal?" sorts
 * ahead of every letter and "Ça Va ?" misses the other C titles. Product names
 * are read by their first letter, so `ignorePunctuation` puts them under Q and
 * C. `numeric` compares a trailing number by value, so "Storyworks 10" follows
 * "Storyworks 9" rather than "Storyworks 1".
 */
const productNameCollator = new Intl.Collator('en', {
  ignorePunctuation: true,
  numeric: true,
});

export function compareProductNames(a: string, b: string): number {
  return productNameCollator.compare(a, b);
}

export interface ProductDisplayOrderAccessors<T> {
  name: (item: T) => string;
  isMagazine: (item: T) => boolean;
}

export function byProductDisplayOrder<T>({
  name,
  isMagazine,
}: ProductDisplayOrderAccessors<T>): (a: T, b: T) => number {
  return (a, b) => {
    const aIsMagazine = isMagazine(a);

    if (aIsMagazine !== isMagazine(b)) {
      return aIsMagazine ? 1 : -1;
    }

    return compareProductNames(name(a), name(b));
  };
}
